import UsersTable from "./UsersTable";

export default function Managers() {
  return <UsersTable type="manager" />;
}
